<template>
  <div v-if="src">
    <div class="audio-container">
      <div class="c-t">
        <div class="play-image">
          <img v-if="!isPlaying" style="width: 100%;cursor: pointer" @click="startPlayOrPause" src="./播放1.png" alt="">
          <img v-else style="width: 100%;cursor: pointer" @click="startPlayOrPause" src="./暂停1.png" alt="">
        </div>
        <div id="waveform" ref="waveform">
        </div>
      </div> 
      <div class="c-b">
        <audio
            v-show="false"
            ref="audio"
            @timeupdate="onTimeupdate"
            @loadedmetadata="onLoadedmetadata"
            :src="src" controls="controls"></audio>
        <div class="c-b-l">
          <span
              style="margin-right: 15px;">{{ audio.currentTime | formatSecond }}/{{ audio.maxTime | formatSecond }}</span>
          <!--                    <span v-show="!isPlaying" @click="startPlayOrPause" class="btn">播放</span>-->
          <!--                    <span v-show="isPlaying" @click="startPlayOrPause" class="btn">暂停</span>-->
        </div>
        <div class="c-b-r">
          <span v-if="isRecordingSplit && permission" @click="cancellationRecordingSplit" style="margin-right: 15px;">取消分割</span>
          <span v-if="isRecordingSplit && permission" @click="cutAudioHandler" style="margin-right: 15px;">录音分割</span>
          <span style="margin-right: 15px;width: 30px;" @click="speedChangeHandler" type="text"
                size="mini"> X {{ speedArr[speed] }}</span>
          <el-popover
              placement="top"
              width="400"
              trigger="click">
            <el-slider v-model="volume" @change="changeCurrentVolume" class="slider"></el-slider>
            <span type="text" size="mini" slot="reference">音量：{{ volume }}</span>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js'
import CursorPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.js'
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js'
import Region from 'wavesurfer.js/dist/plugin/wavesurfer.regions'

let play = require('./播放1.png')
let stop = require('./暂停1.png')

// 将整数转换成 时：分：秒的格式
function realFormatSecond(second) {
  var secondType = typeof second
  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60
    return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '0:00:00'
  }
}

export default {
  name: 'vueAplayer',
  props: {
    src: {
      required: true
    },
    permission: {

    },
    splitPoint: {
      required: false
    },isRecordingSplit: {
      required: false,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      speedArr: [1, 1.5, 2],
      speed: 0,
      volume: 70,
      sliderTime: 0,
      isPlaying: false,
      isChange: false,
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0
      },
      options: [
        {
          value: 1,
          label: '1x'
        },
        {
          value: 1.5,
          label: '1.5x'
        },
        {
          value: 2,
          label: '2x'
        },
      ]
    }
  },
  mounted() {
    console.log(WaveSurfer)
    this.$nextTick(() => {
      this.wavesurfer = WaveSurfer.create({
        // 应该在其中绘制波形的CSS选择器或HTML元素。这是唯一必需的参数。
        barWidth: 3,
        barHeight: 1,
        container: this.$refs.waveform,
        // 光标的填充颜色，指示播放头的位置。
        cursorColor: '#3988fa',
        // 更改波形容器的背景颜色。
        backgroundColor: '#fff',
        height: '30',
        // 光标后的波形填充颜色。
        waveColor: '#82b3d1',
        // 光标后面的波形部分的填充色。当progressColor和waveColor相同时，完全不渲染进度波
        progressColor: '#4c90fa',
        backend: 'MediaElement',
        // 音频播放时间轴
        mediaControls: false,
        // 播放音频的速度
        audioRate: '1',
        // 插件：此教程配置了光标插件和时间轴插件
        plugins: [
          // 光标插件
          CursorPlugin.create({
            showTime: true,
            opacity: 1,
            customShowTimeStyle: {
              'background-color': '#000',
              color: '#fff',
              'font-size': '10px'
            }
          }),
          // 时间轴插件

          // Timeline.create({
          //   container: '#wave-timeline',
          //   secondaryColor: '#FF0000',//次要时间标签颜色，红色
          //   secondaryFontColor: '#FF0000',
          //   // secondaryLabelInterval: this._secondaryLabelInterval,
          //   primaryColor: '#3498DB',//主要时间标签颜色，蓝色
          //   primaryFontColor: '#D3498DB',
          //   primaryLabelInterval: this._primaryLabelInterval,
          //   formatTimeCallback: this._formatTimeCallback,
          //   // timeInterval: this._timeInterval,
          //   labelPadding: 2
          // }),
        ]
      });
      this.wavesurfer.on('error', function (e) {
      });
      this.wavesurfer.load(this.src);
      this.wavesurfer.on('audioprocess', (e) => {
        this.audio.currentTime = e
      })
      this.wavesurfer.on('finish', (e) => {
        this.isPlaying = false
      })
      this.wavesurfer.on('ready',  () => {
        if(this.splitPoint) {
          this.addSeparator(this.splitPoint);
        }
      });
      // console.log()
    })
  },
  methods: {
    cutAudioHandler() {
      this.addSeparator(this.audio.currentTime)
      window.pubsub.emit('splitAudio',this.audio.currentTime)
    },
    cancellationRecordingSplit() {
      var separator = document.getElementsByClassName('separator')[0];
      console.log(separator);
      window.pubsub.emit('cancelsplitAudio',this.audio.currentTime)
      separator.style.display = 'none'
    },
    //添加分割 
    addSeparator(time) {
      let width = this.$refs.waveform.offsetWidth
      console.log(width,time,this.wavesurfer.getDuration());
      var separatorContainer = document.getElementById('waveform');
      let separatorBefore = document.getElementsByClassName('separator')[0]
      if(separatorBefore) {
        separatorContainer.removeChild(separatorBefore);
      }
      var separator = document.createElement('div');
      separator.className = 'separator';
      separator.style.left = width * (time / this.wavesurfer.getDuration()) + 'px'; // 根据时间计算位置
      separatorContainer.appendChild(separator);
    },
    _secondaryLabelInterval(pxPerSec) {
      if (pxPerSec >= 20 && pxPerSec < 40) {
        return 12
      } else if (pxPerSec >= 0 && pxPerSec < 20) {
        return 10
      } else {
        return Math.floor(10 / this._timeInterval(pxPerSec))
      }
    },
    _primaryLabelInterval(pxPerSec) {
      var retval = 1
      if (pxPerSec >= 100) {
        retval = 2
      } else if (pxPerSec >= 80) {
        retval = 1
      } else if (pxPerSec >= 60) {
        retval = 1
      } else if (pxPerSec >= 40) {
        retval = 5
      } else if (pxPerSec >= 20) {
        retval = 2
      } else {
        retval = 1
      }
      return retval
    },
    /**
     * @param pxPerSec
     * @return 以分钟为单位的值
     */
    _timeInterval(pxPerSec) {
      var retval = 1
      if (pxPerSec >= 100) { // 0.5,1,1.5,2,...,9.5,10
        retval = 0.5
      } else if (pxPerSec >= 80) { // 1,2,...,9,10
        retval = 1
      } else if (pxPerSec >= 60) { // 2,4,6,8,10
        retval = 2
      } else if (pxPerSec >= 40) { // 5,10
        retval = 1
      } else if (pxPerSec >= 20) {
        retval = 5
      } else {
        retval = Math.ceil(0.5 / pxPerSec) * 60
      }
      return retval
    },
    _formatTimeCallback(seconds, pxPerSec) {
      seconds = Number(seconds)
      var minutes = Math.floor(seconds / 60)
      seconds = seconds % 60
      var secondsStr = Math.round(seconds).toString()
      if (pxPerSec >= 25 * 10) {
        secondsStr = seconds.toFixed(2)
      } else if (pxPerSec >= 25 * 1) {
        secondsStr = seconds.toFixed(1)
      }
      if (minutes > 0) {
        if (seconds < 10) {
          secondsStr = '0' + secondsStr
        }
        return `${minutes}:${secondsStr}`
      }
      return secondsStr
    },
    // 控制音频的播放与暂停
    startPlayOrPause() {
      // return this.audio.playing ? this.pause() : this.play()
      this.wavesurfer.playPause()
      this.isPlaying = this.wavesurfer.isPlaying()
      this.$emit('startPlayOrPause',this.isPlaying)
    },
    // 播放音频
    play() {
      this.$refs.audio.play()
      this.isChange = false
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause()
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      this.audio.maxTime = parseInt(res.target.duration)
    },
    inputCurrentTime(index) {

    },
    changeCurrentTime(index) {
      this.$refs.audio.currentTime = parseInt(index / 100 * this.audio.maxTime)
      if (index === 0) {
        this.audio.currentTime = 0
        this.pause()
        setTimeout(() => {
          this.play()
        })
      }
    },
    changeCurrentVolume(index) {
      // this.$refs.audio.volume = index / 100
      this.wavesurfer.setVolume(index / 100)
    },
// 当音频当前时间改变后，进度条也要改变
    onTimeupdate(res) {
      console.log(this.isChange, this.audio.currentTime)
      if (this.isChange) {
        // this.audio.currentTime = res.target.currentTime
        // console.log(this.isChange,this.audio.currentTime)
        // if(this.audio.currentTime == 0) {
        //   this.pause()
        // }
        return
      } else {
        this.audio.currentTime = res.target.currentTime
        console.log('currentTime', this.audio.currentTime)
        console.log('target', res.target.currentTime)
        this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
      }//此处为了解决拖动超过一秒不能定位的问题

    },

// 进度条格式化toolTip
    formatProcessToolTip(index = 0) {
      index = parseInt(this.audio.maxTime / 100 * parseInt(index))
      return '进度条: ' + realFormatSecond(parseInt(index))
    },
    speedChangeHandler() {
      this.speed += 1
      if (this.speed > 2) {
        this.speed = 0
      }
      this.wavesurfer.setPlaybackRate(this.speedArr[this.speed])
    },
  },
  filters: {
    // 使用组件过滤器来动态改变按钮的显示
    transPlayPause(value) {
      return value ? stop : play
    },
    // 将整数转化成时分秒
    formatSecond(second = 0) {
      return realFormatSecond(second)
    }
  }
}
</script>
<style lang="scss">
.separator {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: red; /* 设置分隔线的颜色 */
  z-index: 2; /* 保证分隔线在波形上方显示 */
  &::before {
    content: "";
    position: absolute;
    bottom: 0px;
    left: -4.5px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid red;
  }
}
</style>
<style lang="scss" scoped>

.audio-container {
  display: flex;
  flex-direction: column;
  height: 50px;

  .c-t {
    .play-image {
      width: 5%;
    }

    display: flex;
    align-items: center;
    justify-content: space-between;

    #waveform {
      width: 100%;
      position: relative;
    }
  }

  .c-b {
    height: 20px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #4c90fa;
    color: #fff;
    font-size: 12px;

    span {
      cursor: pointer;
      line-height: 14px;
    }

    .c-b-l {
      height: 100%;
      display: flex;
      align-items: center;

      .btn {
        cursor: pointer;
      }
    }

    .c-b-r {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}

</style>
